module.exports = __webpack_public_path__ + "img/P61-zh.8eb91e47.png";